import { Field, useField } from "formik";
import React from "react";

import { Column, Row } from "@gamedev-web/gamedev-sdk-core";

import * as styles from "../CheckBoxField/CheckBoxField.module.css";
import * as commonStyles from "../commonStyles/commonStyles.module.css";
import { FieldErrorMessage } from "../FieldErrorMessage";
import { FieldHeader, FieldHeaderProps, FieldStateProps } from "../FieldHeader";
import { TextField } from "../TextField";
import { useSetFieldTouched } from "../useSetFieldTouched";

export type CheckBox = Readonly<{
  value: string;
  label: string;
  subtitle?: string;
  isCustomOption?: boolean;
}>;

export enum DisplayOptions {
  row = "ROW",
  column = "COLUMN",
}
export type CheckBoxFieldProps = Readonly<{
  checkBoxes: CheckBox[];
  display?: DisplayOptions;
  customOptionFieldName?: string;
  customOptionTitle?: string;
  name: string;
}> &
  FieldHeaderProps &
  FieldStateProps;

export const CheckBoxField = (props: CheckBoxFieldProps) => {
  const {
    name,
    checkBoxes,
    display,
    isSaving,
    disabled,
    customOptionFieldName,
    customOptionTitle,
  } = props;
  const [field] = useField(props);
  useSetFieldTouched(field.name);

  const displayMapOptions = new Map([
    [DisplayOptions.row, styles.displayOptionsAsRow],
    [DisplayOptions.column, undefined],
  ]);

  return (
    <Row className={commonStyles.container}>
      <Column>
        <FieldHeader {...props} />
        <div role="group" aria-labelledby="checkbox-group">
          <div className={display ? displayMapOptions.get(display) : styles.displayOptionsAsGrid}>
            {checkBoxes.map(checkBox => (
              <Row key={`checkbox-${checkBox.value}`}>
                <Column>
                  <label className={styles.option}>
                    <Field
                      type="checkbox"
                      name={name}
                      value={disabled ? false : checkBox.value}
                      data-testid={name}
                      disabled={isSaving || disabled}
                    />
                    {checkBox.label}
                  </label>
                  {checkBox.subtitle && <p className={styles.subtitle}>{checkBox.subtitle}</p>}
                  {customOptionFieldName &&
                    checkBox.isCustomOption &&
                    field.value?.includes(checkBox.value) === true && (
                      <Row>
                        <Column>
                          <TextField
                            name={customOptionFieldName as string}
                            title={customOptionTitle}
                            isRequiredField={true}
                            isSaving={isSaving}
                          />
                        </Column>
                        <Column />
                      </Row>
                    )}
                </Column>
              </Row>
            ))}
          </div>
        </div>
        <FieldErrorMessage fieldName={field.name} />
      </Column>
    </Row>
  );
};
